import styled from 'styled-components';

import { TextButtonLink } from '@creditornot/cb-button';
import { Popover } from '@creditornot/cb-popover';
import { NavigationBar } from 'common/components/cookbook/NavigationBar/NavigationBar';
import { PageApiError } from 'common/components/cookbook/PageApiError';
import { PopoverContent } from 'common/components/cookbook/PopoverContent';
import { Stack } from 'common/components/cookbook/Stack';
import { ViewMeta } from 'common/components/cookbook/ViewMeta';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { BoardSetNavigation } from './BoardSetNavigation';
import { DashboardTabs } from './DashboardTabs';
import { useDashboardsQuery } from './query';
import useDashboardEmbed from './useDashboardEmbed';
import { useDashboardRoute } from './useDashboardRoute';
import useEmbedUrl from './useEmbedUrl';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  iframe {
    flex: 1;
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const DashboardStack = styled(Stack)`
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const InnerDashboardStack = styled(Stack)`
  overflow: hidden;
  width: 100%;
`;

// does not require localization
export default function AnalyticsDashboardView() {
  const f = useFormatMessage();
  const { dashboardId } = useDashboardRoute();
  const embedUrl = useEmbedUrl();
  const createEmbedRef = useDashboardEmbed(embedUrl);
  const pageTitle = f('analytics.analytics');
  const { error } = useDashboardsQuery();

  return (
    <ViewMeta title={pageTitle}>
      <NavigationBar
        title="Analytics"
        titleContent={<BoardSetNavigation />}
        rightContent={
          <Stack direction="row" gap="regularLarge" alignItems="center" justifyContent="center">
            {embedUrl && (
              <Popover
                content={<PopoverContent>Redirects you to looker.wolt.com</PopoverContent>}
                placement="bottom-end"
                openOnHover
                zIndex={1}
              >
                {({ refProps }) => (
                  <TextButtonLink
                    {...refProps}
                    href={embedUrl.replace('looker.wolt.com/embed/', 'looker.wolt.com/')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Explore in Looker
                  </TextButtonLink>
                )}
              </Popover>
            )}
          </Stack>
        }
      />
      <DashboardStack direction="row">
        <InnerDashboardStack>
          <DashboardTabs />
          {error && <PageApiError error={error} />}
          <Root ref={createEmbedRef} key={dashboardId} />
        </InnerDashboardStack>
      </DashboardStack>
    </ViewMeta>
  );
}
